<script setup lang="ts">
const shareButton = ref()

const shareData = {
  title: (document.querySelector('h1')?.innerText ?? document.title).replace(
    /(^|[^&])#(\w+)/g,
    '',
  ),
  media: document.querySelector('img')?.src,
  url: document.location.href,
}

const shareLinks = [
  {
    title: 'Facebook',
    url:
      'https://www.facebook.com/sharer/sharer.php?u=' +
      encodeURIComponent(shareData.url),
  },
  {
    title: 'X (Twitter)',
    url:
      'https://twitter.com/intent/tweet?text=' +
      encodeURIComponent(shareData.url),
  },
  {
    title: 'E-mail',
    url:
      'mailto:%20?&subject=' +
      encodeURIComponent(shareData.title) +
      '&body=' +
      encodeURIComponent(shareData.url),
  },
]

const canShare = !!navigator.share

function share() {
  if (!!navigator.share) {
    navigator.share({
      title: 'Outspot',
      text: shareData.title.split(' - ')[0],
      url: shareData.url,
    })
  } else {
  }
}

onMounted(() => {
  const selectElement = document.createElement('select')

  shareLinks.forEach((shareLink) => {
    const option = document.createElement('option')

    option.value = shareLink.url
    option.innerText = shareLink.title

    selectElement.appendChild(option)
  })

  selectElement.value = ''
  selectElement.selectedIndex = -1
  selectElement.classList.add('select-in-button')

  selectElement.addEventListener('change', () => {
    if (selectElement.value) {
      if (selectElement.value === 'native') {
        navigator.share(shareData)
      } else if (selectElement.value.startsWith('mailto')) {
        location.href = selectElement.value
      } else {
        openInBrowser(selectElement.value, true)
      }
      selectElement.selectedIndex = -1
    }
  })

  if (shareButton.value && shareButton.value instanceof HTMLElement) {
    shareButton.value?.appendChild(selectElement)
  }
})
</script>

<template>
  <div v-if="!canShare" class="os-share-button" ref="shareButton">
    <ion-button inert tertiary>
      <ion-icon :icon="ioniconsShareSocialOutline" slot="icon-only" />
    </ion-button>
  </div>
  <ion-button v-else @click="share()" tertiary>
    <ion-icon :icon="ioniconsShareSocialOutline" slot="icon-only" />
  </ion-button>
</template>

<style>
.os-share-button {
  position: relative;
  display: inline-block;
}

.os-share-button select {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
</style>
